import { render, staticRenderFns } from "./chargeCabinet-order-list.vue?vue&type=template&id=254b78e2&scoped=true&"
import script from "./chargeCabinet-order-list.vue?vue&type=script&lang=js&"
export * from "./chargeCabinet-order-list.vue?vue&type=script&lang=js&"
import style0 from "./chargeCabinet-order-list.vue?vue&type=style&index=0&id=254b78e2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "254b78e2",
  null
  
)

export default component.exports